import { LoadableApp } from 'ui-seeker/core'
import { FL_CONNECTIVITY } from 'app/config'

const AirConnectivity = LoadableApp(import('./AirConnectivity'))

const PageRoutes = [
    { path: FL_CONNECTIVITY.path, component: AirConnectivity, needLogin: true },
]

export default PageRoutes